import PassportRecordRequirementTable from "./PassportRecordRequirementTable";

export default PassportRecordRequirementTable;